/* ---------------------------------------------------------------------------
   PK Cart (style test theme "different style 3")

   THE OFFER (two free prints per order in total):
     - buy 2 prints: free shipping
     - buy 3 prints: 1 free print, chosen in 6x8", A4, 12x16" or A3
     - once that free print is in the cart, spend £150: 1 free Large print,
       chosen in 18x24" or A2

   WHAT COUNTS TOWARDS THE £150 — READ BEFORE CHANGING. Real money, line by
   line: each line's price minus whatever discount sits on it. On a framed
   free print that leaves exactly the frame charge, because the app discounts
   the unframed value of that size, so a customer who frames their free print
   has that frame money counted. Only the Large print's own line is excluded.

   The discount app cannot do the same sum — it reads ORIGINAL line prices,
   before discounts — so its rules use an offset instead: the free print's
   line is included in the group and the threshold is raised by that size's
   unframed value (£163 for 6x8, £166 for A4, £170 for 12x16 and A3). The
   two approaches agree on what the customer actually spends: £150. If those
   app thresholds change, or another discount starts applying to ordinary
   print lines, this sum and the app's will drift apart — the app counts
   pre-discount, this counts post-discount.

   THE TOP BAR TRACKS THE CURRENT GOAL, and its fill tracks progress towards
   THAT goal, not always the shipping one:
       1  Add N more prints for free shipping        (prints / 2)
       2  You have unlocked free shipping!           (held for 2s, once)
       3  Add N more prints for a free print         (prints / 3)
       4  Claim your free print below                (full)
       5  Add £X more to get a free Large print      (spend / £150)
       6  Claim your free Large print below          (full)
       7  Every offer unlocked                       (full)
   The 2s hold fires once per session so it cannot re-trigger every time the
   customer adds and removes prints. While holding, renderGoalBar returns
   early and schedules one more render — do not remove that timeout or the
   bar sticks on the hold message until the next cart change.

   HOW THE PRICE IS MADE FREE: the Functions Creator app, function
   "Poster Kings Free Prints". This file tags the chosen print with ONE hidden
   line item property:
       _pk_gift = free-6x8 | free-A4 | free-12x16 | free-A3
       _pk_gift = large-18x24 | large-A2
   The app takes the UNFRAMED price of that size off that one line.

   LAPSED GIFTS — READ BEFORE CHANGING. The app's paid-print group excludes
   lines by tag, so when a claimed print goes back to full price it must LOSE
   ITS TAG. releaseLapsedGifts() does that, and the ORDER MATTERS: delete the
   tagged line FIRST, then re-add it untagged. Adding first corrupts the cart
   — the untagged copy lands, the cart re-qualifies, the app re-discounts the
   still-present tagged line, and the delete leaves BOTH, a duplicate print
   the customer never added. The trade-off of delete-first is that a failed
   re-add loses the print, so it is retried once and a line that fails twice
   is never retried again.

   LINE CONTROLS: "Add frame / Remove frame" swaps between framed and
   unframed variants of the same size; "Change size" opens the native option
   list of an invisible <select> via showPicker(), on paid poster lines only.
   Both end in swapVariant. KNOWN BEHAVIOUR: Shopify cannot change a line's
   variant, so a swap adds the new one and removes the old, and the print
   moves to the end of the cart.

   Other notes:
   - Dawn listens for any "change" event inside <cart-drawer-items> and treats
     it as a quantity edit, so the capture-phase change listener at the bottom
     stops grid dropdowns AND the line size dropdown reaching it.
   - Every dynamic text/HTML write goes through writeText()/writeHTML(), which
     only write when the value differs. Writing unconditionally triggers this
     file's own MutationObserver and creates an infinite render loop.
   - When submitting this file through a GraphQL block string, never use
     backslash-escaped quotes: they get saved literally.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var CFG = {
    giftEvery: 3,
    giftMax: 1,

    giftKey: '_pk_gift',
    lapsedGiftMs: 1500,
    shipUnlockHoldMs: 2000,
    unframedValues: ['unframed', 'no frame', 'none', ''],
    sizeOption: 'Size',
    frameOption: 'Frame',
    sectionId: 'cart-drawer',

    frameSwatches: {
      black: '#111111',
      white: '#f4f4f4',
      oak: '#d2a76a',
      walnut: '#6b3f26',
      natural: '#d2a76a'
    },

    /* Real Gelato UK shipping rates, in pence. Unframed prints share a tube
       (up to 5); framed prints share a box (up to 3). Within each tube/box
       the largest print pays the "single" rate and every other print in it
       pays its own "additional" rate. */
    shipUnframedByGroup: {
      xs: { rank: 1, single: 364, additional: 18 },
      s:  { rank: 1, single: 364, additional: 18 },
      m:  { rank: 1, single: 364, additional: 18 },
      l:  { rank: 2, single: 396, additional: 29 },
      xl: { rank: 2, single: 396, additional: 29 }
    },
    shipFramedByGroup: {
      xs: { rank: 1, single: 427, additional: 285 },
      s:  { rank: 1, single: 427, additional: 285 },
      m:  { rank: 2, single: 869, additional: 429 },
      l:  { rank: 3, single: 1049, additional: 549 },
      xl: { rank: 3, single: 1049, additional: 549 }
    },
    shipUnframedTubeSize: 5,
    shipFramedBoxSize: 3
  };

  var busy = false;
  var productCache = {};
  var renderTimer = null;
  var renderGeneration = 0;
  var refreshGeneration = 0;
  var enforceBonusFailedKeys = {};
  var mergeAttemptedVariantIds = {};
  var lapsedSince = {};
  var releaseFailedKeys = {};
  var shipHoldUntil = 0;

  var SHIP_STATE_KEY = 'pk_ship_state';
  var SHIP_SEEN_KEY = 'pk_ship_unlocked_shown';

  /* ---------- helpers ---------- */

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || (root() + 'cart');
  }

  function money(cents) {
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat('en', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + code;
    }
  }

  function writeText(el, value) {
    if (!el || el.textContent === value) return;
    el.textContent = value;
  }
  function writeHTML(el, value) {
    if (!el || el.innerHTML === value) return;
    el.innerHTML = value;
  }

  function isUnframed(value) {
    var v = String(value || '').toLowerCase().trim();
    return CFG.unframedValues.indexOf(v) !== -1;
  }

  function optionIndex(product, name) {
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i] && product.options[i].name === name) return i;
    }
    return -1;
  }

  function giftSizeCode(sizeStr) {
    var s = String(sizeStr || '').toLowerCase();
    if (s.indexOf('a4') !== -1) return 'A4';
    if (s.indexOf('a3') !== -1) return 'A3';
    if (s.indexOf('a2') !== -1) return 'A2';
    if (s.indexOf('6x8') !== -1) return '6x8';
    if (s.indexOf('12x16') !== -1) return '12x16';
    if (s.indexOf('18x24') !== -1) return '18x24';
    return '';
  }

  function shipSizeGroup(sizeStr) {
    var s = String(sizeStr || '').toLowerCase();
    if (s.indexOf('30x40') !== -1 || s.indexOf('33.1x46.8') !== -1 || s.indexOf('a0') !== -1) return 'xl';
    if (s.indexOf('24x32') !== -1 || s.indexOf('23.4x33.1') !== -1 || s.indexOf('a1') !== -1) return 'l';
    if (s.indexOf('18x24') !== -1 || s.indexOf('16.5x23.4') !== -1 || s.indexOf('a2') !== -1) return 'm';
    if (s.indexOf('12x16') !== -1 || s.indexOf('11.7x16.5') !== -1 || s.indexOf('a3') !== -1) return 's';
    if (s.indexOf('6x8') !== -1 || s.indexOf('8.3x11.7') !== -1 || s.indexOf('a4') !== -1) return 'xs';
    return 's';
  }

  function packShippingCost(units, chunkSize) {
    var sorted = units.slice().sort(function (a, b) { return b.rank - a.rank; });
    var total = 0;
    for (var i = 0; i < sorted.length; i += chunkSize) {
      var chunk = sorted.slice(i, i + chunkSize);
      total += chunk[0].single;
      for (var j = 1; j < chunk.length; j++) total += chunk[j].additional;
    }
    return total;
  }

  function computeRealShippingCents(lines) {
    var unframedUnits = [];
    var framedUnits = [];

    lines.forEach(function (l) {
      var group = shipSizeGroup(l.size);
      var rate = l.unframed ? CFG.shipUnframedByGroup[group] : CFG.shipFramedByGroup[group];
      if (!rate) return;
      var bucket = l.unframed ? unframedUnits : framedUnits;
      for (var i = 0; i < l.qty; i++) bucket.push(rate);
    });

    return packShippingCost(unframedUnits, CFG.shipUnframedTubeSize) +
      packShippingCost(framedUnits, CFG.shipFramedBoxSize);
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }

  function addItems(items) {
    return postJSON(root() + 'cart/add.js', { items: items });
  }

  function changeLine(key, quantity) {
    return postJSON(root() + 'cart/change.js', { id: key, quantity: quantity });
  }

  function loadProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch(root() + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        productCache[handle] = p;
        return p;
      });
  }

  function refreshDrawer() {
    refreshGeneration += 1;
    var myRefresh = refreshGeneration;
    return fetch(cartUrl() + '?section_id=' + CFG.sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (myRefresh !== refreshGeneration) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.drawer__inner');
        var dst = document.querySelector('cart-drawer .drawer__inner');
        if (src && dst) dst.innerHTML = src.innerHTML;
        if (window.pkHeaderCart && window.pkHeaderCart.refresh) window.pkHeaderCart.refresh();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && !drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open();
        scheduleRender();
      });
  }

  function settledRefresh() {
    return refreshDrawer().then(function () {
      return new Promise(function (resolve) {
        setTimeout(function () {
          refreshDrawer().then(resolve).catch(resolve);
        }, 400);
      });
    });
  }

  /* ---------- state ---------- */

  function readLines() {
    var out = [];
    document.querySelectorAll('[data-pk-line]').forEach(function (el) {
      var unit = parseInt(el.getAttribute('data-pk-unit-price'), 10) || 0;
      var qty = parseInt(el.getAttribute('data-pk-qty'), 10) || 0;
      var finalAttr = el.getAttribute('data-pk-final-cents');
      out.push({
        el: el,
        key: el.getAttribute('data-pk-key'),
        handle: el.getAttribute('data-pk-handle'),
        variantId: el.getAttribute('data-pk-variant'),
        qty: qty,
        size: el.getAttribute('data-pk-size') || '',
        frame: el.getAttribute('data-pk-frame') || '',
        unframed: el.getAttribute('data-pk-unframed') === 'true',
        giftTag: el.getAttribute('data-pk-gift-tag') || '',
        discounted: el.getAttribute('data-pk-discounted') === 'true',
        bonusDiscounted: el.getAttribute('data-pk-bonus-discounted') === 'true',
        type: el.getAttribute('data-pk-type') || '',
        unitPrice: unit,
        /* what the customer actually pays on this line */
        finalCents: finalAttr === null ? unit * qty : (parseInt(finalAttr, 10) || 0)
      });
    });
    return out;
  }

  function lineByKey(key) {
    return readLines().filter(function (l) { return l.key === key; })[0];
  }

  function isLiveGift(line) {
    return !!line.giftTag && line.discounted;
  }

  function isLargeTag(line) {
    return String(line.giftTag || '').indexOf('large-') === 0;
  }

  function shipConfig() {
    var el = document.querySelector('[data-pk-ship-config]');
    if (!el) return { mode: 'amount', min: 2 };
    return {
      mode: el.getAttribute('data-mode') || 'amount',
      min: parseInt(el.getAttribute('data-min'), 10) || 2
    };
  }

  function bonusConfig() {
    var el = document.querySelector('[data-pk-bonus-config]');
    if (!el) return { min: 150 };
    return { min: parseFloat(el.getAttribute('data-min')) || 150 };
  }

  function computeState(lines) {
    var count = 0;
    var giftsInCart = 0;
    lines.forEach(function (l) {
      if (isLiveGift(l)) {
        giftsInCart += l.qty;
        return;
      }
      count += l.qty;
    });
    var giftsAllowed = Math.min(CFG.giftMax, Math.floor(count / CFG.giftEvery));
    return { count: count, giftsInCart: giftsInCart, giftsAllowed: giftsAllowed, owed: giftsAllowed - giftsInCart };
  }

  /* Spend = real money on every line except the Large print's own, so the
     frame charge on a free print counts. See the header. */
  function computeBonusState(lines) {
    var spendCents = 0;
    var bonusInCart = 0;
    lines.forEach(function (l) {
      if (l.bonusDiscounted || isLargeTag(l)) {
        if (l.bonusDiscounted) bonusInCart += l.qty;
        return;
      }
      spendCents += l.finalCents;
    });
    var spend = spendCents / 100;
    var threshold = bonusConfig().min;
    var unlocked = spend >= threshold && bonusInCart === 0;
    return { spend: spend, threshold: threshold, bonusInCart: bonusInCart, unlocked: unlocked };
  }

  function freePrintInCart(state, bonusState) {
    return (state.giftsInCart - bonusState.bonusInCart) > 0;
  }

  function largeOfferOpen(state, bonusState) {
    return bonusState.unlocked && freePrintInCart(state, bonusState);
  }

  function plural(n, word) {
    return n + ' ' + word + (n === 1 ? '' : 's');
  }

  function releaseLapsedGifts(lines) {
    if (busy) return;

    var now = Date.now();
    var present = {};
    var targets = [];

    lines.forEach(function (l) {
      if (!l.giftTag || l.discounted) return;
      present[l.key] = true;
      if (releaseFailedKeys[l.key]) return;
      if (!lapsedSince[l.key]) {
        lapsedSince[l.key] = now;
        return;
      }
      if (now - lapsedSince[l.key] >= CFG.lapsedGiftMs) targets.push(l);
    });

    Object.keys(lapsedSince).forEach(function (k) {
      if (!present[k]) delete lapsedSince[k];
    });

    if (!targets.length) {
      if (Object.keys(lapsedSince).length) {
        setTimeout(function () { if (!busy) scheduleRender(); }, CFG.lapsedGiftMs);
      }
      return;
    }

    busy = true;
    var chain = Promise.resolve();

    targets.forEach(function (line) {
      var variantId = parseInt(line.variantId, 10);
      var qty = line.qty;
      var key = line.key;

      chain = chain.then(function () {
        return changeLine(key, 0)
          .then(function () {
            return addItems([{ id: variantId, quantity: qty }]).catch(function () {
              return addItems([{ id: variantId, quantity: qty }]);
            });
          })
          .then(function () { delete lapsedSince[key]; })
          .catch(function (err) {
            console.warn('[PK Cart] could not release a lapsed gift, will not retry this line', key, err);
            releaseFailedKeys[key] = true;
          });
      });
    });

    chain.then(refreshDrawer).catch(function () {}).then(function () { busy = false; });
  }

  function mergeDuplicateVariants(lines) {
    if (busy) return;

    var groups = {};
    lines.forEach(function (l) {
      if (l.giftTag || l.discounted || !l.variantId || mergeAttemptedVariantIds[l.variantId]) return;
      (groups[l.variantId] = groups[l.variantId] || []).push(l);
    });

    var toMerge = Object.keys(groups).filter(function (id) { return groups[id].length > 1; });
    if (!toMerge.length) return;

    toMerge.forEach(function (id) { mergeAttemptedVariantIds[id] = true; });

    var chain = Promise.resolve();
    toMerge.forEach(function (variantId) {
      var group = groups[variantId];
      var total = group.reduce(function (sum, l) { return sum + l.qty; }, 0);
      var primary = group[0];
      var rest = group.slice(1);
      chain = chain.then(function () { return changeLine(primary.key, total); });
      rest.forEach(function (l) {
        chain = chain.then(function () { return changeLine(l.key, 0); });
      });
    });

    busy = true;
    chain.then(refreshDrawer).catch(function (err) {
      console.warn('[PK Cart] could not merge duplicate lines, will not retry this pair', err);
    }).then(function () { busy = false; });
  }

  /* ---------- render ---------- */

  function scheduleRender() {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(render, 0);
  }

  function render() {
    renderGeneration += 1;
    var myGeneration = renderGeneration;

    var lines = readLines();

    releaseLapsedGifts(lines);
    mergeDuplicateVariants(lines);

    var state = computeState(lines);
    var bonusState = computeBonusState(lines);

    lines.forEach(function (l) {
      var row = l.el.closest('.cart-item');
      if (row) row.classList.toggle('pk-is-gift', l.discounted);
    });

    document.querySelectorAll('[data-pk-frame-wrap]').forEach(function (w) {
      var key = w.getAttribute('data-pk-for-key');
      var line = lines.filter(function (l) { return l.key === key; })[0];
      var toggle = w.querySelector('[data-pk-add-frame]');
      if (line && toggle) writeText(toggle, line.unframed ? 'Add frame' : 'Remove frame');
    });

    renderPicker(state, bonusState, lines);
    renderBonusPicker(state, bonusState, lines);
    renderGoalBar(state, bonusState);
    renderRealShipping(lines);
    setTimeout(function () {
      if (myGeneration !== renderGeneration) return;
      var freshLines = readLines();
      renderGoalBar(computeState(freshLines), computeBonusState(freshLines));
    }, 80);
    enforceBonusGift(lines);
  }

  function syncCardSizes(card, freeMode) {
    var select = card.querySelector('[data-pk-gift-size]');
    if (!select) return;

    if (!card._pkAllSizes) {
      card._pkAllSizes = Array.prototype.map.call(select.options, function (o) {
        return {
          value: o.value,
          text: o.textContent,
          money: o.getAttribute('data-pk-money') || '',
          eligible: o.getAttribute('data-pk-eligible') === 'true'
        };
      });
    }

    var mode = freeMode ? 'free' : 'all';
    if (card._pkSizeMode === mode) return;
    card._pkSizeMode = mode;

    var list = card._pkAllSizes.filter(function (s) { return mode === 'all' || s.eligible; });

    if (!list.length) {
      card.style.display = 'none';
      return;
    }
    if (card.style.display) card.style.display = '';

    var current = select.value;
    while (select.options.length) select.remove(0);
    list.forEach(function (s) {
      var opt = document.createElement('option');
      opt.value = s.value;
      opt.textContent = s.text;
      opt.setAttribute('data-pk-money', s.money);
      opt.setAttribute('data-pk-eligible', s.eligible ? 'true' : 'false');
      select.appendChild(opt);
    });
    var keep = list.filter(function (s) { return s.value === current; })[0];
    select.value = keep ? keep.value : list[0].value;
  }

  function renderPicker(state, bonusState, lines) {
    var picker = document.querySelector('[data-pk-gift-picker]');
    var heading = document.querySelector('[data-pk-gift-heading]');
    if (!picker) return;

    if (!lines.length) { picker.hidden = true; return; }

    var unlocked = state.owed > 0;
    picker.classList.toggle('is-unlocked', unlocked);
    picker.setAttribute('data-pk-unlocked', unlocked ? 'true' : 'false');

    if (heading) {
      heading.hidden = !unlocked;
      if (unlocked) writeText(heading, 'Add your free print');
    }

    var grid = picker.querySelector('.pk-gift__grid');
    if (grid) {
      var wantDisplay = largeOfferOpen(state, bonusState) ? 'none' : '';
      if (grid.style.display !== wantDisplay) grid.style.display = wantDisplay;
    }

    picker.querySelectorAll('[data-pk-gift-card]').forEach(function (card) {
      syncCardSizes(card, unlocked);
      updateCardButton(card, unlocked);
    });
    picker.hidden = false;
  }

  function renderBonusPicker(state, bonusState, lines) {
    var picker = document.querySelector('[data-pk-bonus-picker]');
    var heading = document.querySelector('[data-pk-bonus-heading]');
    if (!picker) return;

    if (!lines.length || !largeOfferOpen(state, bonusState)) { picker.hidden = true; return; }

    if (heading) {
      heading.hidden = false;
      writeText(heading, 'Add your free Large print');
    }

    picker.querySelectorAll('[data-pk-bonus-card]').forEach(function (card) { updateBonusCardButton(card); });
    picker.hidden = false;
  }

  function updateCardButton(card, unlocked) {
    var button = card.querySelector('[data-pk-gift-add]');
    var select = card.querySelector('[data-pk-gift-size]');
    if (!button || !select) return;
    if (unlocked) {
      writeText(button, '+ Add free');
    } else {
      var opt = select.options[select.selectedIndex];
      var price = opt ? (opt.getAttribute('data-pk-money') || '') : '';
      writeText(button, price ? '+ Add ' + price : '+ Add');
    }
  }

  function updateBonusCardButton(card) {
    var button = card.querySelector('[data-pk-bonus-add]');
    if (!button) return;
    writeText(button, '+ Add free');
  }

  function currentGoal(state, bonusState) {
    var ship = shipConfig();
    var freeLive = freePrintInCart(state, bonusState);
    var largeLive = bonusState.bonusInCart > 0;
    var count = state.count;

    if (count < ship.min) {
      return {
        html: 'Add <strong>' + plural(ship.min - count, 'more print') + '</strong> for free shipping',
        pct: (count / ship.min) * 100,
        won: false
      };
    }

    if (!freeLive && count < CFG.giftEvery) {
      return {
        html: 'Add <strong>' + plural(CFG.giftEvery - count, 'more print') + '</strong> for a free print',
        pct: (count / CFG.giftEvery) * 100,
        won: false
      };
    }

    if (!freeLive) {
      return { html: '<strong>Claim your free print below</strong>', pct: 100, won: true };
    }

    if (!largeLive && bonusState.spend < bonusState.threshold) {
      var leftCents = Math.round((bonusState.threshold - bonusState.spend) * 100);
      return {
        html: 'Add <strong>' + money(leftCents) + ' more</strong> to get a free Large print',
        pct: (bonusState.spend / bonusState.threshold) * 100,
        won: false
      };
    }

    if (!largeLive) {
      return { html: '<strong>Claim your free Large print below</strong>', pct: 100, won: true };
    }

    return { html: '<strong>Every offer unlocked, enjoy your free prints</strong>', pct: 100, won: true };
  }

  function paintBar(bar, textEl, html, pct, won) {
    bar.classList.toggle('pk-free-shipping--unlocked', !!won);
    writeHTML(textEl, html);
    document.documentElement.style.setProperty(
      '--pk-fill-width',
      Math.min(100, Math.max(0, Math.round(pct))) + '%'
    );
  }

  function renderGoalBar(state, bonusState) {
    var ship = shipConfig();
    if (ship.mode !== 'prints') return;

    var bar = document.querySelector('.pk-free-shipping[data-pk-threshold]');
    var textEl = bar && bar.querySelector('.pk-free-shipping__text');
    if (!bar || !textEl) return;

    var now = Date.now();
    var shipUnlocked = state.count >= ship.min;

    if (now < shipHoldUntil) {
      paintBar(bar, textEl, '<strong>You have unlocked free shipping!</strong>', 100, true);
      return;
    }

    var prev = '';
    var alreadyShown = false;
    try { prev = sessionStorage.getItem(SHIP_STATE_KEY) || ''; } catch (e) {}
    try { alreadyShown = sessionStorage.getItem(SHIP_SEEN_KEY) === '1'; } catch (e) {}
    try { sessionStorage.setItem(SHIP_STATE_KEY, shipUnlocked ? 'unlocked' : 'locked'); } catch (e) {}

    if (shipUnlocked && prev === 'locked' && !alreadyShown) {
      try { sessionStorage.setItem(SHIP_SEEN_KEY, '1'); } catch (e) {}
      shipHoldUntil = now + CFG.shipUnlockHoldMs;
      paintBar(bar, textEl, '<strong>You have unlocked free shipping!</strong>', 100, true);
      setTimeout(function () { scheduleRender(); }, CFG.shipUnlockHoldMs + 100);
      return;
    }

    var goal = currentGoal(state, bonusState);
    paintBar(bar, textEl, goal.html, goal.pct, goal.won);
  }

  function renderRealShipping(lines) {
    var wrap = document.querySelector('.pk-totals[data-pk-base-savings-cents]');
    if (!wrap) return;

    var unlocked = wrap.getAttribute('data-pk-ship-unlocked') === 'true';
    var baseSavings = parseInt(wrap.getAttribute('data-pk-base-savings-cents'), 10) || 0;
    var shipLine = wrap.querySelector('[data-pk-ship-line]');
    var pill = wrap.querySelector('[data-pk-savings-pill]');

    var shipCents = unlocked ? computeRealShippingCents(lines) : 0;

    if (unlocked && shipLine) writeText(shipLine, money(shipCents));

    var totalSavings = baseSavings + shipCents;
    if (pill) {
      if (totalSavings > 0) {
        pill.hidden = false;
        writeText(pill, 'SAVE ' + money(totalSavings));
      } else {
        pill.hidden = true;
      }
    }
  }

  function enforceBonusGift(lines) {
    if (busy) return;
    var bonusLines = lines.filter(function (l) { return l.bonusDiscounted; });
    var totalBonusQty = bonusLines.reduce(function (s, l) { return s + l.qty; }, 0);
    if (totalBonusQty <= 1) {
      enforceBonusFailedKeys = {};
      return;
    }

    var toRemove = bonusLines.slice(1).filter(function (l) { return !enforceBonusFailedKeys[l.key]; });
    if (!toRemove.length) return;

    busy = true;
    var anyFailed = false;
    var chain = Promise.resolve();
    toRemove.forEach(function (line) {
      chain = chain.then(function () {
        return changeLine(line.key, 0).catch(function (err) {
          console.warn('[PK Cart] could not remove extra Large print, will not retry this line', line.key, err);
          enforceBonusFailedKeys[line.key] = true;
          anyFailed = true;
        });
      });
    });
    chain.then(function () {
      if (!anyFailed) return refreshDrawer();
    }).catch(function () {}).then(function () { busy = false; });
  }

  /* ---------- grid adds ---------- */

  function selectedSizeText(select) {
    var opt = select.options[select.selectedIndex];
    return opt ? opt.textContent : '';
  }

  function onGiftAdd(button) {
    if (busy) return;
    var card = button.closest('[data-pk-gift-card]');
    var select = card && card.querySelector('[data-pk-gift-size]');
    var variantId = select && parseInt(select.value, 10);
    if (!variantId) return;

    var state = computeState(readLines());
    var item = { id: variantId, quantity: 1 };

    if (state.owed > 0) {
      var code = giftSizeCode(selectedSizeText(select));
      if (code === '6x8' || code === 'A4' || code === '12x16' || code === 'A3') {
        item.properties = {};
        item.properties[CFG.giftKey] = 'free-' + code;
      }
    }

    busy = true;
    button.disabled = true;

    addItems([item])
      .then(settledRefresh)
      .catch(function (err) {
        console.warn('[PK Cart] add from gift grid failed', err);
        button.disabled = false;
      })
      .then(function () { busy = false; });
  }

  function onBonusGiftAdd(button) {
    if (busy) return;
    var card = button.closest('[data-pk-bonus-card]');
    var select = card && card.querySelector('[data-pk-bonus-size]');
    var variantId = select && parseInt(select.value, 10);
    if (!variantId) return;

    var lines = readLines();
    var state = computeState(lines);
    var bonusState = computeBonusState(lines);
    if (!largeOfferOpen(state, bonusState)) return;

    var code = giftSizeCode(selectedSizeText(select));
    if (code !== '18x24' && code !== 'A2') return;

    var item = { id: variantId, quantity: 1, properties: {} };
    item.properties[CFG.giftKey] = 'large-' + code;

    busy = true;
    button.disabled = true;

    addItems([item])
      .then(settledRefresh)
      .catch(function (err) {
        console.warn('[PK Cart] add free Large print failed', err);
        button.disabled = false;
      })
      .then(function () { busy = false; });
  }

  /* ---------- line controls ---------- */

  function closePopovers(except) {
    document.querySelectorAll('[data-pk-frame-popover]').forEach(function (p) {
      if (p !== except) {
        p.hidden = true;
        var t = p.parentElement && p.parentElement.querySelector('[data-pk-add-frame]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
    document.querySelectorAll('.pk-frame.is-size-open').forEach(function (w) {
      w.classList.remove('is-size-open');
      var t = w.querySelector('[data-pk-size-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  function swapVariant(line, newVariantId) {
    var item = { id: newVariantId, quantity: line.qty };
    if (line.giftTag) {
      item.properties = {};
      item.properties[CFG.giftKey] = line.giftTag;
    }
    return addItems([item]).then(function () { return changeLine(line.key, 0); });
  }

  function errorText(err) {
    if (!err) return 'Something went wrong. Please try again.';
    if (typeof err === 'string') return err;
    if (err.description) return err.description;
    if (err.message) return err.message;
    if (err.errors) {
      if (typeof err.errors === 'string') return err.errors;
      var keys = Object.keys(err.errors);
      if (keys.length) {
        var v = err.errors[keys[0]];
        return keys[0] + ': ' + (Array.isArray(v) ? v.join(', ') : v);
      }
    }
    return 'Something went wrong. Please try again.';
  }

  function onSizeToggle(button) {
    var wrap = button.closest('[data-pk-size-wrap]');
    var select = wrap && wrap.querySelector('[data-pk-line-size]');
    if (!select || busy) return;

    closePopovers(null);

    if (typeof select.showPicker === 'function') {
      try {
        select.showPicker();
        return;
      } catch (e) {
        /* falls through to the visible-select fallback */
      }
    }

    var open = wrap.classList.toggle('is-size-open');
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      try { select.focus(); } catch (e) {}
    }
  }

  function onSizeChange(select) {
    if (busy) return;
    var wrap = select.closest('[data-pk-size-wrap]');
    var key = wrap && wrap.getAttribute('data-pk-for-key');
    var newVariant = parseInt(select.value, 10);
    var line = lineByKey(key);
    if (!line || !newVariant) return;

    if (wrap) wrap.classList.remove('is-size-open');

    if (String(newVariant) === String(line.variantId)) return;

    busy = true;
    wrap.classList.add('is-busy');
    swapVariant(line, newVariant)
      .then(settledRefresh)
      .catch(function (err) {
        console.warn('[PK Cart] size swap failed', err);
        wrap.classList.remove('is-busy');
      })
      .then(function () { busy = false; });
  }

  function onAddFrameToggle(button) {
    var wrap = button.closest('[data-pk-frame-wrap]');
    var pop = wrap && wrap.querySelector('[data-pk-frame-popover]');
    if (!pop || busy) return;

    var key = wrap.getAttribute('data-pk-for-key');
    var line = lineByKey(key);
    if (!line) return;

    if (!line.unframed) {
      busy = true;
      wrap.classList.add('is-busy');
      loadProduct(line.handle).then(function (product) {
        var sizeIdx = optionIndex(product, CFG.sizeOption);
        var frameIdx = optionIndex(product, CFG.frameOption);
        var match = product.variants.filter(function (v) {
          var sameSize = sizeIdx === -1 || v.options[sizeIdx] === line.size;
          return v.available && sameSize && frameIdx !== -1 && isUnframed(v.options[frameIdx]);
        })[0];
        if (!match) throw { description: 'No unframed version of this size was found.' };
        return swapVariant(line, match.id);
      }).then(settledRefresh).catch(function (err) {
        console.warn('[PK Cart] remove frame failed', err);
        wrap.classList.remove('is-busy');
        pop.hidden = false;
        writeHTML(pop, '<p class="pk-frame__loading">' + errorText(err) + '</p>');
      }).then(function () { busy = false; });
      return;
    }

    if (!pop.hidden) {
      pop.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      return;
    }

    closePopovers(pop);
    pop.hidden = false;
    button.setAttribute('aria-expanded', 'true');

    writeHTML(pop, '<p class="pk-frame__loading">Loading frames…</p>');

    loadProduct(line.handle).then(function (product) {
      var sizeIdx = optionIndex(product, CFG.sizeOption);
      var frameIdx = optionIndex(product, CFG.frameOption);
      if (frameIdx === -1) {
        writeHTML(pop, '<p class="pk-frame__loading">No frames available for this print.</p>');
        return;
      }

      var current = product.variants.filter(function (v) { return String(v.id) === String(line.variantId); })[0];
      var basePrice = current ? current.price : line.unitPrice;

      var framed = product.variants.filter(function (v) {
        var sameSize = sizeIdx === -1 || v.options[sizeIdx] === line.size;
        return v.available && sameSize && !isUnframed(v.options[frameIdx]);
      });

      if (!framed.length) {
        writeHTML(pop, '<p class="pk-frame__loading">No frames available for this size.</p>');
        return;
      }

      var html = '';
      framed.forEach(function (v) {
        var name = v.options[frameIdx];
        var swatch = CFG.frameSwatches[String(name).toLowerCase()] || '#999';
        var delta = v.price - basePrice;
        html += '<button type="button" class="pk-frame__option" data-pk-frame-pick="' + v.id + '">' +
          '<span class="pk-frame__swatch" style="background:' + swatch + '"></span>' +
          '<span class="pk-frame__name">+ ' + name + ' Frame</span>' +
          '<span class="pk-frame__price">' + (delta >= 0 ? '+' : '-') + money(Math.abs(delta)) + '</span>' +
          '</button>';
      });
      writeHTML(pop, html);
    }).catch(function (err) {
      writeHTML(pop, '<p class="pk-frame__loading">' + errorText(err) + '</p>');
    });
  }

  function onFramePick(button) {
    if (busy) return;
    var wrap = button.closest('[data-pk-frame-wrap]');
    var pop = wrap && wrap.querySelector('[data-pk-frame-popover]');
    var key = wrap && wrap.getAttribute('data-pk-for-key');
    var newVariant = parseInt(button.getAttribute('data-pk-frame-pick'), 10);
    var line = lineByKey(key);
    if (!line || !newVariant) return;

    busy = true;
    wrap.classList.add('is-busy');
    swapVariant(line, newVariant)
      .then(settledRefresh)
      .catch(function (err) {
        console.warn('[PK Cart] frame swap failed', err);
        wrap.classList.remove('is-busy');
        if (pop) {
          pop.hidden = false;
          writeHTML(pop, '<p class="pk-frame__loading">' + errorText(err) + '</p>');
        }
      })
      .then(function () { busy = false; });
  }

  /* ---------- events ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;

    var sizeToggle = t.closest && t.closest('[data-pk-size-toggle]');
    if (sizeToggle) { e.preventDefault(); onSizeToggle(sizeToggle); return; }

    var frameToggle = t.closest && t.closest('[data-pk-add-frame]');
    if (frameToggle) { e.preventDefault(); onAddFrameToggle(frameToggle); return; }

    var framePick = t.closest && t.closest('[data-pk-frame-pick]');
    if (framePick) { e.preventDefault(); onFramePick(framePick); return; }

    var giftAdd = t.closest && t.closest('[data-pk-gift-add]');
    if (giftAdd) { e.preventDefault(); onGiftAdd(giftAdd); return; }

    var bonusAdd = t.closest && t.closest('[data-pk-bonus-add]');
    if (bonusAdd) { e.preventDefault(); onBonusGiftAdd(bonusAdd); return; }

    var inControls = t.closest && (t.closest('[data-pk-frame-wrap]') || t.closest('[data-pk-size-wrap]'));
    if (!inControls) closePopovers(null);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    var lineSize = t && t.closest && t.closest('[data-pk-line-size]');
    if (lineSize) {
      e.stopPropagation();
      onSizeChange(lineSize);
      return;
    }

    var giftSelect = t && t.closest && t.closest('[data-pk-gift-size]');
    var bonusSelect = t && t.closest && t.closest('[data-pk-bonus-size]');
    if (!giftSelect && !bonusSelect) return;

    e.stopPropagation();

    if (giftSelect) {
      var picker = giftSelect.closest('[data-pk-gift-picker]');
      var card = giftSelect.closest('[data-pk-gift-card]');
      if (picker && card) updateCardButton(card, picker.getAttribute('data-pk-unlocked') === 'true');
    }
  }, true);

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') closePopovers(null);
  });

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () { scheduleRender(); })
      .observe(drawer, { childList: true, subtree: true });
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === 'class' && drawer.classList.contains('active')) scheduleRender();
      });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    watchDrawer();
    scheduleRender();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.pkCart = { render: render, refresh: refreshDrawer, config: CFG };
})();